import React from 'react';

export default function SelectedShipToAddressLabel(props) {
    const { address } = props;
    return (
        <>
            <div className="common-account-dt-mask">{address?.accountName ? address.accountName : ' '}</div>
            <div className="common-shipping-address-dt-mask">{address?.addressLine1}</div>
            <div className="common-shipping-address-dt-mask">
                {' ' +
                    address?.city +
                    ', ' +
                    (address?.region ? address.region + ', ' : '') +
                    address?.postalCode}
            </div>
        </>
    );
}
